import { AuthResponseEnum } from "@/model/communication/auth/Login/AuthResponseEnum";
import { ClientUser } from "@/model/data/authentication/ClientUser";

export class AuthenticationState {
    loginLoading: boolean = false;
    authState: AuthResponseEnum = AuthResponseEnum.NotAuthenticated;
    currentUser: ClientUser = null;
    azureDisplayName: string = null;
    accountUnlockedAt: Date = new Date();
    locale: string = "en";
    passwordValidDays: number = Number.MAX_VALUE;

    constructor() {}
}

export default new AuthenticationState();
